import { type IntlConfig } from 'react-intl/src/types';
import { List, ListItem } from '@chakra-ui/react';
import { Typography } from '@shinetools/sunshine-universal';

import { webAppLang, webAppLocales } from './common/i18n';

/**
 * Main React IntlProvider config, to share same config within the web-app and storybook
 */
export const intlConfig: IntlConfig = {
  defaultLocale: 'fr',
  defaultRichTextElements: {
    bold: (chunks) => (
      <Typography.Text bold tag="span">
        {chunks}
      </Typography.Text>
    ),
    discreet: (chunks) => (
      <Typography.Text tag="span" variant="discreet">
        {chunks}
      </Typography.Text>
    ),
    list: (chunks) => <List spacing="space-4">{chunks}</List>,
    list_item: (chunks) => (
      <ListItem lineHeight="base" listStyleType="disc" marginLeft="1em">
        {chunks}
      </ListItem>
    ),
    nbsp: '\u00A0',
    subtitle: (chunks) => (
      <Typography.Text size="small" tag="span" variant="secondary">
        {chunks}
      </Typography.Text>
    ),
  },
  locale: webAppLang,
  messages: webAppLocales[webAppLang],
};
